import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TrackingPageState } from './tracking-page.reducer';

const selectTrackingPageStateSelector = createFeatureSelector<
  TrackingPageState
>('trackingPage');

const selectTrackingPageState = (state: TrackingPageState) =>
  state.trackingPage;

export const selectTrackingPage = createSelector(
  selectTrackingPageStateSelector,
  selectTrackingPageState
);

const selectTrackingPageHashState = (state: TrackingPageState) => state.hash;

export const selectTrackingPageHash = createSelector(
  selectTrackingPageStateSelector,
  selectTrackingPageHashState
);

const selectReviewsEnabledState = (state: TrackingPageState) =>
  state.reviewsEnabled;
export const selectReviewsEnabled = createSelector(
  selectTrackingPageStateSelector,
  selectReviewsEnabledState
);

const selectTrackingPageLoadedState = (state: TrackingPageState) =>
  state.trackingPageLoaded;

export const selectTrackingPageLoaded = createSelector(
  selectTrackingPageStateSelector,
  selectTrackingPageLoadedState
);

const selectNoTrackingNumberFoundState = (state: TrackingPageState) =>
  state.noTrackingNumberFound;
export const selectNoTrackingNumberFound = createSelector(
  selectTrackingPageStateSelector,
  selectNoTrackingNumberFoundState
);
